export const DEFAULT_CATEGORY = 'ALL';
export const RECENT_GAMES_CATEGORY = 'recent-games';
export const SET_CATEGORIES = 'SET_CATEGORIES';
